export const pad = (n: number) => n.toString().padStart(2, "0");

export const formatSecondsToMMSS = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    return `${pad(minutes)}:${pad(remainingSeconds)}`;
};
